import styled from 'styled-components'

export const Text = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
`

export const InputWrapper = styled.div`
  margin: 20px 0;
`
